import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';

const client = new ApolloClient({
 	uri: 'https://db.brownandkay-ejfw.temp-dns.com/graphql/',
    
});

export default client;
